/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminPatchUserByUserUuidReqBodyDto
 */
export interface AdminPatchUserByUserUuidReqBodyDto {
    /**
     * 유저 레벨
     * @type {string}
     * @memberof AdminPatchUserByUserUuidReqBodyDto
     */
    'level'?: AdminPatchUserByUserUuidReqBodyDtoLevelEnum;
    /**
     * 서포터즈 여부
     * @type {boolean}
     * @memberof AdminPatchUserByUserUuidReqBodyDto
     */
    'isSupporter'?: boolean;
    /**
     * 수호신 여부
     * @type {boolean}
     * @memberof AdminPatchUserByUserUuidReqBodyDto
     */
    'isGuardian'?: boolean;
    /**
     * 관리자의 해당 유저 즐겨찾기 여부
     * @type {boolean}
     * @memberof AdminPatchUserByUserUuidReqBodyDto
     */
    'isStarred'?: boolean;
    /**
     * 관리자의 해당 유저 차단 여부
     * @type {boolean}
     * @memberof AdminPatchUserByUserUuidReqBodyDto
     */
    'isBanned'?: boolean;
    /**
     * 관리자의 유저 메모
     * @type {string}
     * @memberof AdminPatchUserByUserUuidReqBodyDto
     */
    'memo'?: string;
    /**
     * 지급할 포인트
     * @type {number}
     * @memberof AdminPatchUserByUserUuidReqBodyDto
     */
    'point'?: number;
    /**
     * 환급 가능 금액으로 전환되기 까지 지연되는 일 수
     * @type {number}
     * @memberof AdminPatchUserByUserUuidReqBodyDto
     */
    'exchangeablePointConvertDelayDays'?: number;
}

export const AdminPatchUserByUserUuidReqBodyDtoLevelEnum = {
    Baby: 'baby',
    Friends: 'friends',
    Family: 'family',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Both: 'both'
} as const;

export type AdminPatchUserByUserUuidReqBodyDtoLevelEnum = typeof AdminPatchUserByUserUuidReqBodyDtoLevelEnum[keyof typeof AdminPatchUserByUserUuidReqBodyDtoLevelEnum];


